// extracted by mini-css-extract-plugin
module.exports = {"receving":"receving_receving__2qdEU","content":"receving_content__v0Ka_","total":"receving_total__gqvP8"};